import React from "react";
import { connect } from "react-redux";
import { Div, Span } from "components/Base";
import { actions, getters } from "Portal/CallForPapersForm/model";
import moment from "moment-timezone";

const decorate = connect(
  state => ({
    loggedInLabel: getters.loggedInLabel(state),
    isLoggedIn: getters.isLoggedIn(state),
    isViewingDraftSubmission: getters.isViewingDraftSubmission(state),
    draftSubmissionUpdatedAt: getters.draftSubmissionUpdatedAt(state)
  }),
  {
    handleLogout: actions.handleLogout
  }
);

const LoggedInAs = ({
  isLoggedIn,
  loggedInLabel,
  handleLogout,
  isViewingDraftSubmission,
  draftSubmissionUpdatedAt
}) => {
  return (
    <>
      {isViewingDraftSubmission ? (
        <Div width={1} textAlign="center" mt={7} mb={2} fs={2}>
          Last saved on{" "}
          {moment(draftSubmissionUpdatedAt).format("ddd MMMM D, YYYY, h:mm A")}
        </Div>
      ) : null}
      {!isLoggedIn ? null : (
        <Div
          textAlign="center"
          mt={isViewingDraftSubmission ? 0 : 7}
          pb={5}
          width={1}
        >
          You are logged in as {loggedInLabel}. Not you?{" "}
          <Span
            tabIndex={0}
            onClick={handleLogout}
            underline
            aria-role="button"
            aria-label="Click here to log out"
          >
            Click here to log out.
          </Span>
        </Div>
      )}
    </>
  );
};

export default decorate(LoggedInAs);
